import { fieldServiceTypeOptions } from "@/common/const/filter-options";
import fieldServiceHoursOptions from "@/common/const/filter-options/fieldServiceHours.options";
import quoteCreationTypeOptions from "@/common/const/quote/quoteCreationTypes.const";
import { ColumnsStrategy, PriceType } from "@/common/types";
import { QuoteActions } from "@/components";
import QuoteCreationTypeTag from "@/components/Quotes/QuoteCreationType/QuoteCreationTypeTag";
import PickQuoteLineElement from "@/components/Quotes/SingleQuoteResults/PickQuoteLineElement";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  FilterSelect,
  OptionsCell,
} from "@/components/TableComponents";
import RangeFilter from "@/components/TableComponents/Head/RangeFilter";
import SortComponent from "@/components/TableComponents/Head/SortComponent";

const fieldServiceQuoteResultsStrategy: ColumnsStrategy[] = [
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => (
      <PickQuoteLineElement data={record} key={record.id} />
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: (
      <FilterSelect
        fieldName="filters-fieldServiceType"
        values={fieldServiceTypeOptions}
      />
    ),
    name: "price",
    render: (value: PriceType) => (
      <OptionsCell
        value={value.hoursType || "No data"}
        options={fieldServiceHoursOptions}
        key={JSON.stringify(value)}
      />
    ),
    headerClassName: "!bg-white !pb-[22px]",
  },

  {
    label: (
      <SortComponent
        childKey="noOfHours"
        title="No. of Hours"
        tooltipVariants={[
          "From smallest to largest",
          "Form largest to smallest",
        ]}
      />
    ),
    name: "price",
    render: (value: PriceType) => (
      <DefaultTextColumn
        text={value.noOfHours || "No data"}
        className="py-0"
        key={value.id + Math.random().toFixed()}
      />
    ),
    headerClassName: "!bg-white !pb-[18x]",
  },
  {
    label: <DefaultHeadColumns text="Currency" key={"Currency"} />,
    name: "price",
    render: (value: any, record: any) => (
      <DefaultTextColumn
        className="py-0"
        text={value.targetCurrency}
        key={record.id}
      />
      // <div key={record.id}>{value.targetCurrency}</div>
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: (
      <RangeFilter
        fieldName="filters-targetOTC"
        title="OTC"
        max={100000}
        min={0}
      />
    ),
    name: "price",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          className="py-0 text-primary"
          text={
            value.targetOTC === null
              ? "0"
              : Number.parseFloat(value.targetOTC).toFixed(2)
          }
          key={[value.id, record.id, value.targetOTC].join("-")}
        />
      );
    },
    headerClassName: "!bg-white !pb-[30px]",
  },
  {
    label: (
      <FilterSelect
        fieldName="filters-fieldServiceType"
        values={fieldServiceTypeOptions}
      />
    ),
    name: "price",
    render: (value: PriceType, record: any) => (
      <OptionsCell
        value={value.fieldServiceType || "No data"}
        options={fieldServiceTypeOptions}
        key={`${value.id}  ${record.id}  ${value.fieldServiceType}`}
      />
    ),
    headerClassName: "!bg-white !pb-[22px]",
  },

  {
    label: (
      <FilterSelect
        fieldName="filters-quoteLineType"
        values={quoteCreationTypeOptions}
      />
    ),
    name: "quoteType",
    render: (value: "Firm" | "Budgetary", record: any) => (
      <QuoteCreationTypeTag quoteCreationType={value} key={record.id} />
    ),
    headerClassName: "!bg-white !pb-[22px]",
  },
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => <QuoteActions quoteLine={record} />,
    headerClassName: "!bg-white !pb-3",
  },
];
const fieldServiceQuoteResultsStrategyWithoutFilters: ColumnsStrategy[] = [
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => (
      <PickQuoteLineElement data={record} key={record.id} />
    ),
    headerClassName: "!bg-white !pb-3",
  },

  {
    label: <DefaultHeadColumns text="Field Service Type" />,
    name: "price",
    render: (value: PriceType) => (
      <OptionsCell
        value={value.hoursType || "No data"}
        options={fieldServiceHoursOptions}
        key={JSON.stringify(value)}
      />
    ),
    headerClassName: "!bg-white !pb-3",
  },

  {
    label: <DefaultHeadColumns text="No. Of Hours" />,
    name: "price",
    render: (value: PriceType) => (
      <DefaultTextColumn
        text={value.noOfHours || "No data"}
        className="py-0"
        key={value.id + Math.random().toFixed()}
      />
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="Currency" key={"Currency"} />,
    name: "price",
    render: (value: any, record: any) => (
      <DefaultTextColumn
        text={value.targetCurrency}
        key={value.currency + record.id}
        className="py-0"
      />
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: <DefaultHeadColumns text="OTC" key={"OTC"} />,
    name: "price",
    render: (value: any, record: any) => {
      return (
        <DefaultTextColumn
          labelClassName="text-primary"
          className="py-0 text-primary"
          text={
            value.targetMRC === null
              ? "0"
              : Number.parseFloat(value.targetOTC).toFixed(2)
          }
          key={[value.id, record.id, value.targetOTC].join("-")}
        />
      );
    },
    headerClassName: "!bg-white !pb-3 ",
  },
  {
    label: <DefaultHeadColumns text="Field Service Type" />,
    name: "price",
    render: (value: PriceType, record: any) => (
      <OptionsCell
        value={value.fieldServiceType || "No data"}
        options={fieldServiceTypeOptions}
        key={`${value.id}  ${record.id}  ${value.fieldServiceType}`}
      />
    ),
    headerClassName: "!bg-white !pb-3",
  },

  {
    label: <DefaultHeadColumns text="Quote Type" />,
    name: "quoteType",
    render: (value: "Firm" | "Budgetary", record: any) => (
      <QuoteCreationTypeTag quoteCreationType={value} key={record.id} />
    ),
    headerClassName: "!bg-white !pb-3",
  },
  {
    label: "",
    name: "id",
    render: (_: number, record: any) => <QuoteActions quoteLine={record} />,
    headerClassName: "!bg-white !pb-3",
  },
];

export {
  fieldServiceQuoteResultsStrategy,
  fieldServiceQuoteResultsStrategyWithoutFilters,
};
